import axios from '@/services/axios'

const AUTH_ME_CACHE_TTL_MS = 15 * 1000

let authMeInFlight = null
let authMeCachedResponse = null
let authMeCachedAt = 0

function isCacheFresh() {
  return Boolean(authMeCachedResponse) && (Date.now() - authMeCachedAt) < AUTH_ME_CACHE_TTL_MS
}

export async function fetchAuthMe(options = {}) {
  const forceRefresh = Boolean(options.forceRefresh)
  const timeout = Number(options.timeout || 10000)

  if (!forceRefresh && isCacheFresh()) {
    return authMeCachedResponse
  }

  if (authMeInFlight) {
    return authMeInFlight
  }

  authMeInFlight = axios.get('/api/auth/me', {
    withCredentials: true,
    timeout,
  })
    .then(response => {
      authMeCachedResponse = response
      authMeCachedAt = Date.now()

      return response
    })
    .finally(() => {
      authMeInFlight = null
    })

  return authMeInFlight
}

export function clearAuthMeCache() {
  authMeCachedResponse = null
  authMeCachedAt = 0
  authMeInFlight = null
}
